import { OrganizationBusinessUnit } from './organizationBusinessUnits.models';

export interface OrganizationBusinessUnitsState {
  ids: string[];
  entities: Record<string, OrganizationBusinessUnit>;
  isLoaded: boolean;
  isLoading: boolean;
  error: string | null;
}

type Action =
  | {
      type: 'SET_LOADING_STATE';
      payload: Pick<OrganizationBusinessUnitsState, 'isLoading' | 'isLoaded'>;
    }
  | { type: 'FETCH_ORGANIZATION_BUSINESS_UNITS' }
  | {
      type: 'FETCH_ORGANIZATION_BUSINESS_UNITS_SUCCESS';
      payload: { businessUnits: OrganizationBusinessUnit[] };
    }
  | {
      type: 'FETCH_ORGANIZATION_BUSINESS_UNITS_FAILURE';
      payload: { error: string };
    };

export const initState: OrganizationBusinessUnitsState = {
  ids: [],
  entities: {},
  isLoaded: false,
  isLoading: false,
  error: null,
};

export const organizationBusinessUnitsReducer = (
  state: OrganizationBusinessUnitsState,
  action: Action
): OrganizationBusinessUnitsState => {
  switch (action.type) {
    case 'SET_LOADING_STATE':
      return {
        ...state,
        ...action.payload,
        error: null,
      };

    case 'FETCH_ORGANIZATION_BUSINESS_UNITS':
      return {
        ...state,
        isLoading: true,
        isLoaded: !!state.ids.length,
        error: null,
      };
    case 'FETCH_ORGANIZATION_BUSINESS_UNITS_SUCCESS':
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        ids: [
          ...new Set(
            action.payload.businessUnits.map(
              (businessUnit) => businessUnit.organizationBusinessUnitId
            )
          ),
        ],
        entities: action.payload.businessUnits.reduce(
          (acc, businessUnit) => ({
            ...acc,
            [businessUnit.organizationBusinessUnitId]: businessUnit,
          }),
          {}
        ),
      };

    case 'FETCH_ORGANIZATION_BUSINESS_UNITS_FAILURE':
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        error: action.payload.error,
      };

    default:
      return state;
  }
};
